/**
 * Enova Looks Section - Swiper init
 */
(function() {
  var sections = document.querySelectorAll('.enova-looks');

  sections.forEach(function(section) {
    var swiperEl = section.querySelector('.enova-looks__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var colsDesktop = parseInt(swiperEl.dataset.columnsDesktop) || 4;
    var colsTablet = parseInt(swiperEl.dataset.columnsTablet) || 3;
    var colsMobile = parseFloat(swiperEl.dataset.columnsMobile) || 2;
    var spaceBetween = parseInt(swiperEl.dataset.spaceBetween) || 16;

    var prevBtn = section.querySelector('.enova-looks__arrow--prev');
    var nextBtn = section.querySelector('.enova-looks__arrow--next');

    var config = {
      slidesPerView: colsMobile,
      spaceBetween: spaceBetween,
      watchOverflow: true,
      breakpoints: {
        750: { slidesPerView: colsTablet },
        990: { slidesPerView: colsDesktop }
      }
    };

    if (prevBtn && nextBtn) {
      config.navigation = { prevEl: prevBtn, nextEl: nextBtn };
    }

    new Swiper(swiperEl, config);
  });
})();
